import { Epic } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ofType } from '@alycecom/utils';
import { handleError, handlers } from '@alycecom/services';

import { fetchCodeData } from './codeData.actions';
import { ICodeData } from './codeData.types';

export const fetchDataEpic: Epic = (action$, state$, { apiService }) =>
  action$.pipe(
    ofType(fetchCodeData.pending),
    switchMap(({ payload: { hashId } }) =>
      apiService.get(`/api/recipient/code/${hashId}/data`).pipe(
        map((response: ICodeData) => fetchCodeData.fulfilled(response)),
        catchError(handleError(handlers.handleAnyError(fetchCodeData.rejected()))),
      ),
    ),
  );

export const codeDataEpics = [fetchDataEpic];
